module.exports = __webpack_public_path__ + "static/media/pastors.47d6f0c5.png";